import { getBackendUrl, getFrontendUrl } from "../config";

/**
 * Socket.IO roda no mesmo servidor HTTP do backend Node.
 * Em produção, usar FRONTEND_URL costuma apontar para CDN/nginx sem proxy de /socket.io.
 */
export function resolveSocketUrl() {
	const backend = getBackendUrl();
	const frontend = getFrontendUrl();
	if (backend && backend.trim() !== "") {
		return backend.trim().replace(/\/$/, "");
	}
	if (frontend && String(frontend).trim() !== "") {
		return String(frontend).trim().replace(/\/$/, "");
	}
	return "http://localhost:8080";
}
